/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext } from 'react'

const DebugContext = createContext(false)

export const DebugProvider = DebugContext.Provider

export function useDebug() {
  return useContext(DebugContext)
}
